import { LOGIN_SUCCESS, LOGOUT } from '../actions/loginActions';

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => (error ? prom.reject(error) : prom.resolve(token)));
  failedQueue = [];
};

const authMiddleware = ({ dispatch, getState }) => next => (action) => {
  if (action.type !== 'API_CALL' || (action.meta && !action.meta.apiRequest)) {
    return next(action);
  }

  const { currentUser = {} } = getState().login;
  const accessToken = currentUser.token;
  const { refreshToken } = currentUser;

  const { url, options } = action.payload;

  const headers = new Headers(options.headers || {});
  if (accessToken) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const originalRequest = {
    url,
    options: {
      ...options,
      headers,
      isRetryRequest: options.isRetryRequest || false,
    },
  };

  const makeApiCall = (token = accessToken) => {
    const modifiedHeaders = new Headers(originalRequest.options.headers);
    if (token) modifiedHeaders.set('Authorization', `Bearer ${token}`);

    return fetch(originalRequest.url, { ...originalRequest.options, headers: modifiedHeaders })
      .then(async (res) => {
        if (!res.ok) throw res;
        const data = await res.json();
        dispatch({ type: action.meta.successType, payload: data });
      })
      .catch(err => dispatch({ type: action.meta.failureType, payload: err.statusText || 'Error de red' }));
  };

  const handleRefresh = () => {
    isRefreshing = true;

    fetch(`${url.split('/api')[0]}/api/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: accessToken, refreshToken }),
    })
      .then(async (res) => {
        if (!res.ok) throw res;
        const data = await res.json();
        dispatch({ type: LOGIN_SUCCESS, payload: data });
        processQueue(null, data.token);
        return makeApiCall(data.token);
      })
      .catch((err) => {
        console.error('Fall� el refresco de token. Cerrando sesi�n.');
        dispatch({ type: LOGOUT });
        processQueue(err, null);
      })
      .finally(() => {
        isRefreshing = false;
      });
  };

  return makeApiCall().catch((error) => {
    if (error.status === 401 && !originalRequest.options.isRetryRequest) {
      originalRequest.options.isRetryRequest = true;

      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      })
        .then(newToken => makeApiCall(newToken))
        .catch((err) => {
          dispatch({ type: action.meta.failureType, payload: err.statusText || 'Error de autenticaci�n' });
        })
        .finally(() => {
          if (!isRefreshing && refreshToken) {
            handleRefresh();
          } else if (!refreshToken) {
            dispatch({ type: LOGOUT });
          }
        });
    }

    return dispatch({ type: action.meta.failureType, payload: error.statusText || 'Error desconocido' });
  });
};


export default authMiddleware;
